import React, { Component } from "react";
import { defaultIcons, getRandomInt } from "Config/AppConfig";

import { FiArrowUp } from "react-icons/fi";
import { Fonts } from "Themes";
import { mobileSize } from "Themes/Metrics";
import styled from "styled-components";

const TabContainer = styled.div`
  border: solid 3px lightgray;
  border-radius: 5px;
  cursor: pointer;
  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
  display: flex;
  margin-bottom: 10px;
  padding: 5px;
  background-color: white;
`;

const TextContainer = styled.div`
  flex: 4;
  padding: 10px;
`;

const Text = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const TabImageContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 1;
  border-radius: 10px;
  @media ${mobileSize.large} {
    flex: 2;
  }
`;

const TabImage = styled.div`
  width: 100%;
  border-radius: 10px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  border: solid 2px lightgray;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ProfileAvatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 100px;
`;

const AvatarContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 10px;
  @media ${mobileSize.large} {
    display: none;
  }
`;

const UpvoteContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  font-family: ${Fonts.primaryFontFamily};
  font-size: 20px;
`;

const Upvote = styled.div`
  border: solid 2px lightgray;
  border-radius: 100px
  height: 50px;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

class ExploreTab extends Component {
  state = {};

  appendEllipsis = (text) => {
    if (!text.length) return;
    if (text.length > 30) {
      return `${text
        .split("")
        .splice(0, 30)
        .join("")}...`;
    }
    return text;
  };

  renderDefaultAvatar = () => {
    const DefaultIcon = defaultIcons[getRandomInt(defaultIcons.length)];
    return <DefaultIcon size={40} style={{ borderRadius: 40 }} />;
  };

  render() {
    const {
      title,
      text,
      avatar,
      image,
      onClick,
      upvote,
      imageError,
    } = this.props;
    return (
      <TabContainer onClick={onClick}>
        {upvote && (
          <UpvoteContainer>
            <Upvote>
              <FiArrowUp fontSize={15} /> {upvote}
            </Upvote>
          </UpvoteContainer>
        )}
        <AvatarContainer>
          {imageError || !avatar ? (
            this.renderDefaultAvatar()
          ) : (
            <ProfileAvatar
              src={avatar}
              alt={"Not found"}
              onError={() => this.setState({ imageError: true })}
            />
          )}
        </AvatarContainer>
        <TextContainer>
          <h3
            style={{
              fontFamily: Fonts.primaryFontFamily,
            }}
          >
            {title}
          </h3>
          <Text>{this.appendEllipsis(text)}</Text>
        </TextContainer>
        <TabImageContainer>
          <TabImage
            style={{
              background: `url(${image})`,
              backgroundSize: "cover",
            }}
          ></TabImage>
        </TabImageContainer>
      </TabContainer>
    );
  }
}

export default ExploreTab;
